<script setup lang="ts">
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { setLanguage } from '@/i18n'
import { supportedLocales, type LocaleCode } from '@/i18n/supportedLocales.ts'
import themeService from '@/services/themeService.ts'

defineEmits<{ 'toggle-menu': [] }>()

const { t, locale } = useI18n()

const isDark = ref(themeService.isDark())

function toggleTheme(): void {
  themeService.toggle()
  isDark.value = themeService.isDark()
}

const localeOptions = supportedLocales.map((l) => ({ label: l.label, value: l.code }))

function onLanguageChange(code: LocaleCode): void {
  setLanguage(code)
}
</script>

<template>
  <header class="layout-topbar">
    <div class="layout-topbar-start">
      <Button icon="pi pi-bars" severity="secondary" text rounded @click="$emit('toggle-menu')" />
      <RouterLink to="/" class="layout-topbar-brand">{{ t('common.appTitle') }}</RouterLink>
    </div>
    <div class="layout-topbar-end">
      <Select
        :model-value="locale"
        :options="localeOptions"
        option-label="label"
        option-value="value"
        size="small"
        :aria-label="t('common.language')"
        data-test="language-select"
        @update:model-value="onLanguageChange"
      />
      <Button
        :icon="isDark ? 'pi pi-moon' : 'pi pi-sun'"
        severity="secondary"
        text
        rounded
        :title="t('common.toggleTheme')"
        :aria-label="t('common.toggleTheme')"
        data-test="theme-toggle"
        @click="toggleTheme"
      />
      <slot name="end" />
    </div>
  </header>
</template>
